/* eslint-disable no-sequences */
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { string as yupstring, object as yupobject } from 'yup'
import {
  TextField,
  Button,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Container,
  Paper,
  IconButton
} from '@material-ui/core'
import { Add, Edit, Clear, Check } from '@material-ui/icons'
import DeleteIcon from '@material-ui/icons/Delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {
  createAdCDNFolder,
  updateAdCDNFolder,
  deleteAdCDNFolder,
  filterCDNFolder,
  fetchAdCDNFolders
} from '../../modules/AdLoaderCDNFoldersSlice'
import { LoadingProgress } from '../ui'
import { commonStyle } from '../../styles'

const swal = withReactContent(Swal)

const StyledTableRow = withStyles(theme => ({
  root: {
    verticalAlign: 'top',
    border: 'none'
  }
}))(TableRow)

const StyledTableCell = withStyles(theme => ({
  root: {
    borderBottom: '1px solid rgba(224, 224, 224, 1)'
  }
}))(TableCell)

export const AdLoaderCDNFolders = props => {
  const commonClasses = commonStyle()
  const dispatch = useDispatch()
  const { adCDNFolders } = useSelector(state => state.adLoaderCDNFoldersSlice)
  const [searchTerm, setSearchTerm] = React.useState('')
  const [adLoaderCDNFolders, setAdLoaderCDNFolders] = useState({})
  const [selectedItem, setSelectedItem] = useState({})
  const [addingNew, setAddingNew] = useState(false)
  const [isEditing, setIsEditing] = useState(false)

  const validationSchema = yupobject().shape({
    name: yupstring().required('Required'),
    folder: yupstring()
      .required('Required')
      .matches(
        '^[a-zA-Z][a-zA-Z0-9_-]*$',
        'Folder must contain only letters, numbers, dash & underscore'
      )
  })

  const {
    register,
    formState: { errors },
    setValue,
    handleSubmit
  } = useForm({
    resolver: yupResolver(validationSchema),
    submitFocusError: false
  })

  const onSearchChange = e => {
    setSearchTerm(e.target.value)
    dispatch(filterCDNFolder(e.target.value))
  }

  // Create new AdLoaderCDNFolders
  const onAddAdCDNFolder = () => {
    setSelectedItem({ name: '', folder: '' })
    setAddingNew(true)
    setIsEditing(true)
    setValue('name', '')
    setValue('folder', '')
  }

  const CreateAdLoaderCDNFolder = () => {
    dispatch(createAdCDNFolder(selectedItem))
    setAddingNew(false)
  }

  // Update AdLoaderCDNFolders
  const onEditAdCDNFolder = adLoaderCDNFolder => {
    setSelectedItem(adLoaderCDNFolder)
    setIsEditing(true)
    setAddingNew(false)
    setValue('name', adLoaderCDNFolder.name, { shouldValidate: true })
    setValue('folder', adLoaderCDNFolder.folder, { shouldValidate: true })
  }

  const handleAdLoaderCDNFolderChange = e => {
    if (e.target.name === 'name') {
      setSelectedItem({
        ...selectedItem,
        name: e.target.value
      })
      setValue('name', e.target.value, { shouldValidate: true })
    } else if (e.target.name === 'folder') {
      setSelectedItem({
        ...selectedItem,
        folder: e.target.value
      })
      setValue('folder', e.target.value, { shouldValidate: true })
    }
  }

  const UpdateAdLoaderCDNFolder = () => {
    dispatch(updateAdCDNFolder(selectedItem))
    setIsEditing(false)
  }

  // Delete AdLoaderCDNFolders
  const onDeleteAdLoaderCDNFolder = adLoaderCDNFolders => {
    swal.fire({
      title: 'Are you sure?',
      text: `Once deleted, will not be able to recover "${adLoaderCDNFolders.name}"!`,
      icon: 'warning',
      showCancelButton: true
      // buttons: true,
      // dangerMode: true
    }).then(willDelete => {
      if (willDelete.isConfirmed) {
        dispatch(deleteAdCDNFolder(adLoaderCDNFolders))
      }
    })
  }

  const textField = (
    isEditing,
    adLoaderCDNFolder,
    textFieldName,
    textFieldDefaultValue,
    handleTextFieldChange,
    error,
    errorMessage
  ) => {
    if (isEditing && selectedItem._id === adLoaderCDNFolder._id) {
      return (
        <TextField
          style={{ width: '100%' }}
          margin='dense'
          defaultValue={textFieldDefaultValue}
          variant='outlined'
          {...register(textFieldName)}
          onChange={e => handleTextFieldChange(e)}
          error={!!error}
          helperText={error ? errorMessage : ''}
        />
      )
    } else {
      return <div className={commonClasses.plainText}>{textFieldDefaultValue}</div>
    }
  }

  useEffect(() => {
    if (adCDNFolders && adCDNFolders.length > 0) {
      setAdLoaderCDNFolders(
        adCDNFolders.map(adCDNFolders => ({ ...adCDNFolders }))
      )
    } else {
      dispatch(fetchAdCDNFolders())
    }
  }, [adCDNFolders])
  return (
    <Container maxWidth='xl'>
      <Paper position='static'>
        <form autoComplete='off' noValidate>
          <CardHeader title='Ad Loader CDN Folders' />
          <Divider />
          <CardContent className={commonClasses.cardBkClr}>
            <Card>
              <CardContent>
                <Grid container>
                  <Grid item md={4} xs={12}>
                    <TextField
                      fullWidth
                      label='Find'
                      margin='dense'
                      name='itemFilter'
                      defaultValue={searchTerm}
                      variant='outlined'
                      onChange={onSearchChange}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <Button
                      variant='contained'
                      color='primary'
                      className={commonClasses.m_1}
                      startIcon={<Add />}
                      onClick={() => {
                        onAddAdCDNFolder()
                      }}
                    >
                      Add New CDN Folder
                    </Button>
                  </Grid>
                  <Grid item md={2} />
                </Grid>
              </CardContent>
            </Card>
            <br />
            <Card>
              <CardContent>
                <Grid>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          style={{ width: '45%', fontWeight: 'bold' }}
                        >
                          Name
                        </TableCell>
                        <TableCell
                          style={{ width: '45%', fontWeight: 'bold' }}
                        >
                          Folder
                        </TableCell>
                        <TableCell
                          style={{ width: '10%', fontWeight: 'bold' }}
                        >
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <StyledTableRow
                        className={!addingNew ? commonClasses.hidden : ''}
                      >
                        <StyledTableCell>
                          <TextField
                            {...register('name')}
                            margin='dense'
                            id={selectedItem.name}
                            value={selectedItem.name ? selectedItem.name : ''}
                            style={{ width: '100%' }}
                            variant='outlined'
                            onChange={e => handleAdLoaderCDNFolderChange(e)}
                            error={!!errors.name}
                            helperText={errors.name ? errors.name.message : ''}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <TextField
                            {...register('folder')}
                            margin='dense'
                            value={selectedItem.folder ? selectedItem.folder : ''}
                            variant='outlined'
                            style={{ width: '100%' }}
                            onChange={e => handleAdLoaderCDNFolderChange(e)}
                            error={!!errors.folder}
                            helperText={errors.folder ? errors.folder.message : ''}
                          />
                        </StyledTableCell>

                        <StyledTableCell style={{ textAlign: 'center' }}>
                          <Grid container>
                            <Grid className={commonClasses.displayFlex} item>
                              <IconButton
                                aria-label='Save'
                                variant='contained'
                                name='Save'
                                title='Save'
                                onClick={handleSubmit(CreateAdLoaderCDNFolder)}
                              >
                                <Check />
                              </IconButton>
                              <IconButton
                                aria-label='Cancel'
                                variant='contained'
                                title='Cancel'
                                name='cancel'
                                onClick={e => {
                                  setAddingNew(false)
                                }}
                              >
                                <Clear />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </StyledTableCell>
                      </StyledTableRow>
                      {adLoaderCDNFolders.length > 0
                        ? (
                            adLoaderCDNFolders.map(adLoaderCDNFolder => (
                              <React.Fragment key={adLoaderCDNFolder._id}>
                                <StyledTableRow>
                                  <StyledTableCell>
                                    {textField(
                                      isEditing,
                                      adLoaderCDNFolder,
                                      'name',
                                      adLoaderCDNFolder.name,
                                      handleAdLoaderCDNFolderChange,
                                      errors.name,
                                      errors.name ? errors.name.message : ''
                                    )}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {textField(
                                      isEditing,
                                      adLoaderCDNFolder,
                                      'folder',
                                      adLoaderCDNFolder.folder,
                                      handleAdLoaderCDNFolderChange,
                                      errors.folder,
                                      errors.folder ? errors.folder.message : ''
                                    )}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    <Grid container>
                                      <Grid className={commonClasses.displayFlex} item>
                                        <IconButton
                                          aria-label='Save'
                                          variant='contained'
                                          className={
                                      isEditing &&
                                      selectedItem._id === adLoaderCDNFolder._id
                                        ? ''
                                        : commonClasses.hidden
                                    }
                                          name='Save'
                                          title='Save'
                                          onClick={handleSubmit(UpdateAdLoaderCDNFolder)}
                                        >
                                          <Check />
                                        </IconButton>
                                        <IconButton
                                          aria-label='Cancel'
                                          variant='contained'
                                          className={
                                      isEditing &&
                                      selectedItem._id === adLoaderCDNFolder._id
                                        ? ''
                                        : commonClasses.hidden
                                    }
                                          title='Cancel'
                                          onClick={e => {
                                            e.stopPropagation()
                                            setIsEditing(false)
                                          }}
                                        >
                                          <Clear />
                                        </IconButton>
                                      </Grid>
                                    </Grid>
                                    <Grid container>
                                      <Grid className={commonClasses.displayFlex} item>
                                        <IconButton
                                          aria-label='Edit'
                                          variant='contained'
                                          className={
                                      isEditing &&
                                      selectedItem._id === adLoaderCDNFolder._id
                                        ? commonClasses.hidden
                                        : commonClasses.editIconColor
                                    }
                                          name='Edit'
                                          title='Edit'
                                          onClick={e => {
                                            onEditAdCDNFolder(adLoaderCDNFolder)
                                          }}
                                        >
                                          <Edit />
                                        </IconButton>
                                        <IconButton
                                          aria-label='Delete'
                                          variant='contained'
                                          className={
                                      isEditing &&
                                      selectedItem._id === adLoaderCDNFolder._id
                                        ? commonClasses.hidden
                                        : commonClasses.editIconColor
                                    }
                                          name='Delete'
                                          title='Delete'
                                          onClick={e => {
                                            onDeleteAdLoaderCDNFolder(adLoaderCDNFolder)
                                          }}
                                        >
                                          <DeleteIcon className={commonClasses.deleteIconColor} />
                                        </IconButton>
                                      </Grid>
                                    </Grid>
                                  </StyledTableCell>
                                </StyledTableRow>
                              </React.Fragment>
                            ))
                          )
                        : (
                          <TableRow>
                            <TableCell colSpan={8}>
                              <LoadingProgress />
                            </TableCell>
                          </TableRow>
                          )}
                    </TableBody>
                  </Table>
                </Grid>
              </CardContent>
            </Card>
          </CardContent>
        </form>
      </Paper>
    </Container>
  )
}
